export const constants = {
  LM_KEY: 'living-meaningfully',
  LM_AUTH: 'LM',
  LM_USER: 'LM-U',
  AUTH_ROUTE: '/auth',
  ENCRYPTION_KEY: 'JaNdRgUkXp2s5v8y/A?D(G+KbPeShVmY',
  TABLE_ROWS: 25,
  HOME_ROUTE: '/app/dashboard',
  DEFAULT_ROUTE: '/landing',
  DEFAULT_PAGE_SIZE: 7,
  TRIBE_URL: 'https://tribe-dev.livingmeaningfully.ca/auth/login',
};

export const APP_MESSAGES = {
  VERIFY_ACCOUNT: 'Kindly verify your account',
};
